import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerShape } from 'react-router/lib/PropTypes';
import Helmet from 'react-helmet';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { login } from 'actions';

import PageHeader from 'AppComponents/PageHeader';
import { Input } from 'AppComponents/Forms/Formsy';
import SubmitButton from 'AppComponents/SubmitButton';
import Alert from 'AppComponents/Alert';
import LoginWrapper from 'AppComponents/LoginWrapper';

import PasswordReset from './PasswordReset';

import './styles.scss';


class Login extends Component {

  static propTypes = {
    error: PropTypes.shape({
      detail: PropTypes.string,
    }),
    isLoggedIn: PropTypes.bool,
    loggingIn: PropTypes.bool,
    loginRequest: PropTypes.func.isRequired,
  };

  static defaultProps = {
    error: null,
    isLoggedIn: false,
    loggingIn: false,
  };

  static contextTypes = {
    router: routerShape.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      formValid: false,
      serverError: null,
      showPasswordReset: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn) this.context.router.push('/user/account/');
    if (nextProps.error) {
      const error = nextProps.error;
      if (typeof error === 'object') {
        this.setState({ serverError: error.detail });
        delete error.detail;
        const errors = {};
        Object.keys(error).forEach((field) => {
          errors[field] = error[field][0];
        });
        this.form.updateInputsWithError(errors);
      }
    }
  }

  @autobind
  handleSubmit(data) {
    this.props.loginRequest(data.username, data.password);
  }

  @autobind
  handleShowPasswordReset(e) {
    e.preventDefault();
    this.setState({ showPasswordReset: true });
  }

  @autobind
  handlePasswordResetClose() {
    this.setState({ showPasswordReset: false });
  }

  render() {
    const { loggingIn } = this.props;

    const { serverError, showPasswordReset, formValid } = this.state;

    return (
      <LoginWrapper>

        <Helmet title='Login' />

        <PageHeader title='Login' />

        <Alert type='danger' display={serverError && true}>
          { serverError }
        </Alert>

        <Formsy.Form
          ref={(c) => { this.form = c; }}
          className='form'
          styleName='form'
          onValid={() => this.setState({ formValid: true })}
          onInvalid={() => this.setState({ formValid: false })}
          onValidSubmit={this.handleSubmit}
          noValidate
        >

          <Input
            name='username'
            label='Username'
            required
          />

          <Input
            type='password'
            name='password'
            label='Password'
            required
          />

          <SubmitButton
            label='Login'
            enabled={formValid}
            isSubmitting={loggingIn}
          />

        </Formsy.Form>

        <p styleName='forgot-password-link'>
          <a
            href='/user/account/password/reset/'
            onClick={this.handleShowPasswordReset}
          >
            Forgot your password?
          </a>
        </p>

        <PasswordReset
          display={showPasswordReset}
          handleClose={this.handlePasswordResetClose}
        />

      </LoginWrapper>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  loggingIn: state.auth.loggingIn,
  error: state.auth.error,
});

const loginRequest = login.request;

export default connect(
  mapStateToProps, {
    loginRequest,
  },
)(Login);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Login/index.jsx